import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingScreen } from "Components";
import { MasterFieldModal } from "./MasterFieldModal";
import { newAuthService } from "Service/Axios";
import { deleteGlobalDataUrl, getGlobalDataListUrl } from "Constant/api";
import { Outlet, useNavigate } from "react-router-dom";
import { paths } from "Constant/paths";
import { toast } from "react-toastify";

export default function MasterData() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [feildModal, setFieldModal] = useState(false);
  const [fieldModalType, setFieldModalType] = useState("add");
  const [selectedField, setSelectedField] = useState(null);
  const [fieldList, setFieldList] = useState([]);

  const toggleFieldModal = (fieldData, type) => {
    setFieldModal(!feildModal);
    setFieldModalType(type || "add");
    if (fieldData) {
      setSelectedField(fieldData);
    } else {
      setSelectedField(null);
    }
  };

  const fetchFieldList = async () => {
    setLoading(true);
    const payload = {};
    const response = await newAuthService(
      getGlobalDataListUrl,
      "POST",
      payload
    );
    if (response.status) {
      setFieldList(response.data);
      setLoading(false);
    } else {
      setFieldList([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFieldList();
  }, []);

  const onDeleteField = async (gid) => {
    try {
      const data = {
        gid,
      };
      const response = await newAuthService(deleteGlobalDataUrl, "POST", data);
      if (response.status) {
        fetchFieldList();
        toast.success(t("common.messages.notification.success.deleteField"));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("common.messages.notification.failed.somethingWentWrong");
    }
  };

  const redirectFieldDetails = (field) => {
    navigate(`${paths.admin.masterData.details}/${field.gid}`);
  };

  return (
    <main className="main">
      <div className="d-flex align-items-center mb-3">
        <div class="page-title-box d-md-flex justify-content-between align-items-center">
          <h4 class="page-title">Admin Master Data</h4>
        </div>
        <div className="ms-auto">
          <button
            type="button"
            className="btn btn-gray-light font-medium rounded-lg d-inline-flex align-items-center gap-1 me-2"
            onClick={() => toggleFieldModal(null, "import")}
          >
            <i className="bx bx-import"></i> Import Field
          </button>
          <button
            type="button"
            className="btn btn-primary font-medium rounded-lg d-inline-flex align-items-center gap-1"
            onClick={() => toggleFieldModal()}
          >
            <i className="bx bx-plus"></i> Add Field
          </button>
        </div>
      </div>

      <div className="table-container mb-4 max-h-800">
        <table className="table table-bordered">
          <thead className="table-light position-sticky top-0 z-20">
            <tr>
              <th>S.No</th>
              <th>Field Name</th>
              <th>Field Type</th>
              <th>Field Description</th>
              <th>No. of Entries</th>
              <th className="text-center">{t("common.label.action")}</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="loading-screen">
                <td colSpan={5}>
                  <LoadingScreen />
                </td>
              </tr>
            ) : (
              fieldList &&
              fieldList.length > 0 &&
              fieldList.map((field, idx) => (
                <tr key={`${field.gid}-${idx}`}>
                  <td>{idx + 1}</td>
                  <td>{field.name}</td>
                  <td>{field.type}</td>
                  <td className="w-400 text-wrap">
                    <div className="w-400 text-wrap">{field.description}</div>
                  </td>
                  <td>{field.details?.length ?? ""}</td>
                  <td>
                    <div className="d-flex justify-content-center align-items-center gap-1">
                      <button
                        type="button"
                        className="button btn btn-transparent px-1 text-primary-500"
                        onClick={() => redirectFieldDetails(field)}
                      >
                        <i className="bx bx-show"></i>
                      </button>
                      <button
                        type="button"
                        className="button btn btn-transparent px-1 text-green-500"
                        onClick={() => toggleFieldModal(field)}
                      >
                        <i className="bx bxs-pencil"></i>
                      </button>
                      <button
                        type="button"
                        className="button btn btn-transparent px-1 text-red-500"
                        onClick={() => onDeleteField(field.gid)}
                      >
                        <i className="bx bx-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Outlet />

      {feildModal && (
        <MasterFieldModal
          show={feildModal}
          modalType={fieldModalType}
          toggle={toggleFieldModal}
          selectedData={selectedField}
          fetchList={fetchFieldList}
        />
      )}
    </main>
  );
}
